module.exports = __webpack_public_path__ + "assets/img/prezp_logo_alternate.e7713622.png";